// src/lib/types/enums.ts

export enum IntervalE {
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}

export enum AuthProviderE {
  EMAIL = 'email',
  GOOGLE = 'google',
  RESEND = 'resend',
  BOXYHQ_SAML = 'boxyhq-saml',
  LINKEDIN = 'linkedin',
  MicrosoftEntraID =  'microsoft-entra-id'
}

export enum RolesE {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ZEUS_ADMIN = 'ZEUS_ADMIN',
  TENANT_ADMIN = 'TENANT_ADMIN',
  TENANT_USER = 'TENANT_USER',
  CUSTOMER_ADMIN = 'CUSTOMER_ADMIN',
  CUSTOMER_USER = 'CUSTOMER_USER'
}

export enum RolesI {
  SUPER_ADMIN = '124edfeb-e937-4bdb-a0ca-c0f69659e665',
  ZEUS_ADMIN = '8d1d9274-d4be-4500-aff4-df461c71f094',
  TENANT_ADMIN = '94adcf00-457a-4337-97fe-5cf2baca863c',
  TENANT_USER = 'ad03dd37-b71b-4aca-9e90-e00dd5f5103c',
  CUSTOMER_ADMIN = '20963e08-8734-42bb-9d14-96e931d8d618',
  CUSTOMER_USER = '93deb48b-7062-445d-80d7-97e16a4abdfe'
}

export enum Actions {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  MANAGE = 'manage'
}

export enum Subjects {
  SUBSCRIPTION = 'Subscription',
  TRACKTRACE = 'Project',
  QUOTE = 'Quote',
  ALL = 'all'
}

export enum StatusTypes {
  // Tenant statuses
  TENANT_ACTIVE = 1,
  TENANT_INACTIVE = 2,
  TENANT_SUSPENDED = 3,

  // Product statuses
  PRODUCT_ACTIVE = 4,
  PRODUCT_INACTIVE = 5,

  // Tenant product subscription statuses
  TENANT_PRODUCT_ACTIVE = 6,
  TENANT_PRODUCT_INACTIVE = 7,

  // User statuses
  USER_ACTIVE = 8,
  USER_INACTIVE = 9,
  USER_SUSPENDED = 10,

  // Role statuses
  ROLE_ACTIVE = 11,
  ROLE_INACTIVE = 12,

  // Data/Record statuses
  DATA_ACTIVE = 13,
  DATA_INACTIVE = 14,

  // Quote statuses
  QUOTE_DRAFT = 15,
  QUOTE_REVIEW = 16,
  QUOTE_APPROVED = 17,
  QUOTE_REJECTED = 18,
  QUOTE_CANCELLED = 19,

  // Party types
  PARTY_SUPPLIER = 20,
  PARTY_CARRIER = 21,
  PARTY_SHIPPER = 22,
  PARTY_CONSIGNEE = 23,

  //Customer statuses
  CUSTOMER_ACTIVE = 24,
  CUSTOMER_INACTIVE = 25,
  CUSTOMER_SUSPENDED = 26
}

export enum ContactRoleTypes {
  BILLING_ADMIN = 'BILLING_ADMIN',
  PRIMARY_CONTACT = 'PRIMARY_CONTACT',
  TECH_CONTACT = 'TECH_CONTACT',
  LOGISTICS_CONTACT = 'LOGISTICS_CONTACT'
}

// Add a helper object for display names
export const ContactRoleNames = {
  [ContactRoleTypes.BILLING_ADMIN]: 'Billing Admin',
  [ContactRoleTypes.PRIMARY_CONTACT]: 'Primary Contact',
  [ContactRoleTypes.TECH_CONTACT]: 'Technical Contact',
  [ContactRoleTypes.LOGISTICS_CONTACT]: 'Logistics Contact'
};

export enum ActivityActionType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  VIEW = 'view'
}


// Shipment Data
export enum ShipmentTransportStatusTypes {
  SHIPMENT_BOOKED = 'BOOKED',
  SHIPMENT_REJECTED = 'REJECTED',
  SHIPMENT_REJECTED_IN_PROCESS = 'REJECTED_IN_PROCESS',
  SHIPMENT_SCHEDULED = 'SCHEDULED',
  SHIPMENT_DISPATCHED = 'DISPATCHED',
  SHIPMENT_TENDERED = 'TENDERED',
  SHIPMENT_CANCELED = 'CANCELED',
  SHIPMENT_IN_PROCESS = 'IN_PROCESS',
  SHIPMENT_IN_TRANSIT = 'IN_TRANSIT',
  SHIPMENT_DELIVERED = 'DELIVERED',
  SHIPMENT_READY = 'READY',
  SHIPMENT_EXCEPTION = 'EXCEPTION',
  SHIPMENT_PICKED_UP = 'PICKED_UP',
  SHIPMENT_OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY'
}

export enum ShipmentTransportModes {
  AIR = 'AIR',
  OCEAN = 'OCEAN',
  RAIL = 'RAIL',
  ROAD = 'ROAD'
}

export enum ShipmentTransportHealthDetails {
  OVERDUE_DELIVERY_UPDATE = 'OVERDUE_DELIVERY_UPDATE',
  LATE = 'LATE',
  RELIABLE = 'RELIABLE',
  EARLY = 'EARLY',
  ON_TIME = 'ON_TIME',
  IMPOSSIBLE_ON_TIME = 'IMPOSSIBLE_ON_TIME',
  CANCELED = 'CANCELED'
}

export enum PartyTypes {
  CONSIGNEE = 'CONSIGNEE',
  CUSTOMER = 'CUSTOMER',
  SHIPPER = 'SHIPPER'
}

export const COUNTRIES = [
  { id: 'us', name: 'United States', code: 'USA' },
  /*{ id: 'ca', name: 'Canada', code: 'CAN' },
  { id: 'mx', name: 'Mexico', code: 'MEX' },
  { id: 'eu', name: 'European Union', code: 'EU' },
  { id: 'gb', name: 'United Kingdom', code: 'GBR' },
  { id: 'cn', name: 'China', code: 'CHN' },
  { id: 'jp', name: 'Japan', code: 'JPN' },
  { id: 'kr', name: 'South Korea', code: 'KOR' },
  { id: 'in', name: 'India', code: 'IND' },
  { id: 'br', name: 'Brazil', code: 'BRA' }*/
] as const;

// Type for country IDs
export type CountryId = typeof COUNTRIES[number]['id'];

// Accessorial Constants
export const ORIGIN_ACCESSORIALS_GTZ = [
  { value: 11, label: "Lift Gate Pickup" },
  { value: 13, label: "Residential Pickup" },
  { value: 103, label: "Notification Pickup" },
  { value: 105, label: "Inside Pickup" },
  { value: 152, label: "Appointment Pickup" },
  { value: 120, label: "Non Commercial Pickup - Airport" },
  { value: 121, label: "Non Commercial Pickup - Construction/Utility Site" },
  { value: 123, label: "Non Commercial Pickup - Military Base" }
];

export const DESTINATION_ACCESSORIALS_GTZ = [
  { value: 12, label: "Lift Gate Delivery" },
  { value: 14, label: "Residential Delivery" },
  { value: 15, label: "Inside Delivery" },
  { value: 17, label: "Notify Prior To Arrival" },
  { value: 104, label: "Notification Delivery" },
  { value: 153, label: "Appointment Delivery" },
  { value: 39, label: "Non Commercial Delivery - Airport" },
  { value: 41, label: "Non Commercial Delivery - Construction/Utility Site" }
];

export const SPECIAL_SERVICES_GTZ = [
  { value: 108, label: "Sort And Segregate" },
  { value: 116, label: "Protect From Freeze" }
];

export const QUOTE_LOCATION_REQUIREMENTS = [
  { value: 201, label: "Appointment Required" },
  { value: 202, label: "Appointment Confirmed With Location" }
]

// Combined lookup for all accessorials
export const ALL_ACCESSORIALS_GTZ = [
  ...ORIGIN_ACCESSORIALS_GTZ,
  ...DESTINATION_ACCESSORIALS_GTZ,
  ...SPECIAL_SERVICES_GTZ,
  ...QUOTE_LOCATION_REQUIREMENTS
];

export const FTL_EQUIPMENT_TYPE = [
        { value: 'ET-0', label: 'Van' },
        { value: 'ET-1', label: 'Flatbed' },
        { value: 'ET-2', label: 'Temp Controlled (Frozen)' },
        { value: 'ET-3', label: 'Temp Controlled (Refrigerated)' },
        { value: 'ET-4', label: 'Power Only' },
        { value: 'ET-5', label: 'RGN' },
        { value: 'ET-6', label: 'Conestoga' },
        { value: 'ET-7', label: 'Curtainside' },
        { value: 'ET-8', label: 'Straight Truck' },
        { value: 'ET-9', label: 'Double Drop' },
        { value: 'ET-10', label: 'Cargo' },
        { value: 'ET-11', label: 'Container' },
        { value: 'ET-12', label: 'Sprinter Van' },
        { value: 'ET-13', label: 'TOFC' },
        { value: 'ET-14', label: 'COFC' },
        { value: 'ET-15', label: 'Bulk' },
        { value: 'ET-16', label: 'Cargo Van' },
        { value: 'ET-17', label: 'Partial TL' },
        { value: 'ET-18', label: 'Drayage' },
        { value: 'ET-19', label: 'Stepdeck' },
        { value: 'ET-20', label: 'Other' },
        { value: 'ET-21', label: 'Hot Shot' },
        { value: 'ET-22', label: 'Van or Reefer' },
        { value: 'ET-23', label: 'Flat or Stepdeck' },
        { value: 'ET-24', label: 'Van or Intermodal' },
        { value: 'ET-25', label: 'Intermodal' },
        { value: 'ET-26', label: 'Reefer Intermodal' }
    ];

export const FTL_EQUIPMENT_LENGTH = [
    { value: 'EL-0', label: 'None' },
    { value: 'EL-1', label: '48 or 53' },
    { value: 'EL-2', label: '40 HC' },
    { value: 'EL-3', label: '45 HC' },
    { value: 'EL-4', label: '48 HC' },
    { value: 'EL-5', label: '53 HC' },
    { value: 'EL-20', label: '20' },
    { value: 'EL-28', label: '28' },
    { value: 'EL-40', label: '40' },
    { value: 'EL-45', label: '45' },
    { value: 'EL-48', label: '48' },
    { value: 'EL-53', label: '53' }
];

export const FTL_EQUIP_LENGTH_MAP = [
    {
        "equipment": 'ET-0',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-1',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-2',
        "lengths": ['EL-53', 'EL-20', 'EL-28', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48', 'EL-1', 'EL-4', 'EL-5']
    },
    {
        "equipment": 'ET-3',
        "lengths": ['EL-53', 'EL-20', 'EL-28', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48', 'EL-1', 'EL-4', 'EL-5']
    },
    {
        "equipment": 'ET-8',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-10',
        "lengths": ['EL-53', 'EL-20', 'EL-28', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48', 'EL-1', 'EL-4', 'EL-5']
    },
    {
        "equipment": 'ET-11',
        "lengths": ['EL-53', 'EL-20', 'EL-28', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48', 'EL-1', 'EL-4', 'EL-5']
    },
    {
        "equipment": 'ET-12',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-13',
        "lengths": ['EL-53', 'EL-20', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48']
    },
    {
        "equipment": 'ET-14',
        "lengths": ['EL-53', 'EL-20', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48']
    },
    {
        "equipment": 'ET-15',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-16',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-17',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-18',
        "lengths": ['EL-53', 'EL-20', 'EL-28', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48', 'EL-1', 'EL-4', 'EL-5']
    },
    {
        "equipment": 'ET-19',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-21',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-22',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-23',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-24',
        "lengths": ['EL-53', 'EL-48', 'EL-1']
    },
    {
        "equipment": 'ET-25',
        "lengths": ['EL-53', 'EL-20', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48']
    },
    {
        "equipment": 'ET-26',
        "lengths": ['EL-53', 'EL-20', 'EL-40', 'EL-2', 'EL-45', 'EL-3', 'EL-48']
    }
];

